<template>
    <div id="verifyIdentityPage">
        <div class="container bg-white py-0 pb-0 pt-2 mb-2">
            <div class="lazada-hc-logo"></div>
            <div class="mt-5">
                <div class="d-flex justify-content-center mb-4">
                    <img alt="" src="/img/hcpay/logo.png" class="" />
                </div>

                <div class="d-flex justify-content-center mx-4">
                    <div class="headline-custom">
                        Open Home Credit app and approve
                        <span
                            class="font-weight-bold nowrap"
                            style="color: #2196f3"
                            >₱{{ toCurrency(this.$root.$data.amount) }}</span
                        >
                        payment to
                        <span class="font-weight-bold" style="color: #2196f3"
                            >Lazada
                        </span>
                    </div>
                </div>
                <div class="d-flex justify-content-center m-4">
                    <div class="d-flex align-items-center">
                        <timer
                            :customExpiration="true"
                            @end="timerEnd"
                            :minutes="15"
                        />
                    </div>
                </div>
            </div>
            <div class="pb-4" style="background: #fafafa">
                <div class="d-flex justify-content-center">
                    <div class="font-md font-weight-bold m-4">How it Works</div>
                </div>
                <div class="d-flex justify-content-center mb-4">
                    <img alt="" src="/img/hcpay/static.png" class="" />
                </div>

                <div class="d-flex mx-2">
                    <img
                        alt=""
                        src="/img/hcpay/Mobile.png"
                        class="mr-3"
                        style="height: auto; width: 32px; height: 32px"
                    />
                    <div>
                        <span class="step-style" style="color: #666666"
                            >Step 1</span
                        >
                        <br />
                        <p class="custom-instruction">
                            {{ EnumLabels.STEP_1 }}
                        </p>
                    </div>
                </div>
                <hr style="width: 95%" />
                <div class="d-flex mx-2">
                    <img
                        alt=""
                        src="/img/hcpay/ab_repayment_vn.png"
                        class="mr-3"
                        style="height: auto; width: 32px; height: 32px"
                    />
                    <div>
                        <span class="step-style" style="color: #666666"
                            >Step 2</span
                        >
                        <br />
                        <p class="custom-instruction">
                            {{ EnumLabels.STEP_2 }}
                        </p>
                    </div>
                </div>
                <hr style="width: 95%" />
                <div class="d-flex mx-2">
                    <img
                        alt=""
                        src="/img/hcpay/Merchant.png"
                        class="mr-3"
                        style="height: auto; width: 32px; height: 32px"
                    />
                    <div>
                        <span class="step-style" style="color: #666666"
                            >Step 3</span
                        >
                        <br />
                        <p class="custom-instruction">
                            Go to the merchant website or app to confirm your
                            successful purchase
                        </p>
                    </div>
                </div>
            </div>
            <div
                class="d-flex flex-column justify-content-center bg-white px-0 pt-5 pb-4 mb-2"
            >
                <div class="px-4">
                    <lazada-payment-summary class="mx-auto" />
                </div>
            </div>
        </div>
        <div class="container bg-white py-0 pb-0 pt-2 mb-2">
            <hr />

            <div class="d-flex justify-content-center pt-2 my-2">
                <button
                    type="button"
                    class="btn btn-success rounded-pill w-75 position-relative mx-4"
                    @click="changeView('help-screen')"
                >
                    <div
                        class="d-flex justify-content-start align-items-center"
                    >
                        <img alt="" src="/img/hcpay/help-icon.svg" />
                        <div
                            class="flex-grow-1 text-center"
                            style="margin-right: 20px"
                        >
                            Visit Our Help Center
                        </div>
                    </div>
                </button>
            </div>
            <div
                class="d-flex flex-column justify-content-center bg-white px-0 pb-4 pb-lg-5"
            >
                <lazada-cancel-request
                    :eventName="'payment_request_click_cancel_go_back'"
                    class="mt-2"
                    >{{
                        EnumLabels.CANCEL_AND_GOBACK_MERCHANT
                    }}</lazada-cancel-request
                >
            </div>
        </div>
        <div class="d-flex flex-column align-items-center p-0"></div>
    </div>
</template>
<script>
import { TRANSACTION_STATUS } from "../../mixins/transaction_status.js";
import { ERROR } from "../../mixins/error_codes.js";
import Download_v3 from "../../components/opg/v3/download_v3.vue";
import { EnumLabels } from "../../enums/CommonString.js";

const accountTypes = {
    PHONE: "Phone2",
    FCBKID: "Fblogo2",
};

export default {
    computed: {
        accountTypeIcon() {
            return accountTypes[this.$root.account.type];
        },
    },
    data() {
        return {
            EnumLabels,
            verifyFailCount: 0,
            timerCallback: null,
            denomination: 0,
        };
    },
    created() {
        this.subscribe();
        this.$root.$data.previousView = "lazada-verification";
        this.$root.$data.transactionId = this.$root.$data.transactionId;
        ec.set("sessionReferenceId", this.$root.$data.referenceNumber);

        let g4Params = {
            userId: this.$root.$data.account.userId,
            cuid: this.$root.$data.account.cuid,
            ip: this.$root.transaction.ipAddress,
            user_agent: this.$root.$data.analyticsData.userAgent,
            phone: this.$root.$data.analyticsData.phone,
            operating_system:
                this.$root.$data.analyticsData.operatingSystem.name +
                "V" +
                this.$root.$data.analyticsData.operatingSystem.version,
            browser:
                this.$root.$data.analyticsData.browser.name +
                "V" +
                this.$root.$data.analyticsData.browser.version,
            transaction_type: "WT",
            transaction_reference: this.$root.$data.referenceNumber,
        };
        this.$root.triggerG4Event("payment_request_page", g4Params);
    },
    methods: {
        googlePlayClick() {
            window.location.href =
                "https://play.google.com/store/apps/details?id=ph.homecredit.myhomecredit&referrer=web_src=nav-bar-btn%26utm_source%3Dgoogle%26utm_medium%3Dcpc%26utm_content%3Dbranded-hc%26utm_campaign%3Ddm-pos-acqui-sem-smphbau-branded-hc-ex-10272023";
        },
        appStoreClick() {
            window.location.href =
                "https://apps.apple.com/ph/app/home-credit-online-loan-app/id1577894172";
        },
        toCurrency(value) {
            // Check if the value is NaN or empty (null, undefined, or other falsy values)
            if (!value || isNaN(value)) {
                value = 0;
            }
            let val = (value / 1).toFixed(2).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        changeView(view) {
            this.$root.$data.view = view;
        },
        timerEnd(callback) {
            this.verifyFailCount++;
            this.timerCallback = callback;
        },
        subscribe() {
            // let vm = this;
            // const tid = this.$root.$data.transactionId;
            // this.$socket.connect(tid, () => {
            //     this.$socket.subscribe(response => {
            //         this.$root.$data.paymentOption = response.paymentOption;
            //         this.$root.$data.paymentOptionLabel = response.paymentOption;
            //         if (
            //             response.status in TRANSACTION_STATUS &&
            //             response.status == TRANSACTION_STATUS.IN_PROGRESS &&
            //             response.transactionID ==
            //                 this.$root.$data.referenceNumber
            //         ) {
            //             this.verifyFailCount--;
            //             this.$root.$data.referenceNumber = this.$root.$data.referenceNumber;
            //             this.changeView("lazada-payment-in-progress");
            //         } else if (
            //             (response.status in TRANSACTION_STATUS &&
            //                 response.status == TRANSACTION_STATUS.CANCELLED &&
            //                 response.transactionID ==
            //                     this.$root.$data.referenceNumber) ||
            //             (response.status in TRANSACTION_STATUS &&
            //                 response.status == TRANSACTION_STATUS.FAILED &&
            //                 response.transactionID ==
            //                     this.$root.$data.referenceNumber) ||
            //             (response.status in TRANSACTION_STATUS &&
            //                 response.status == TRANSACTION_STATUS.REFUNDED &&
            //                 response.transactionID ==
            //                     this.$root.$data.referenceNumber)
            //         ) {
            //             this.changeView("lazada-user-canceled");
            //         } else if (
            //             response.status in TRANSACTION_STATUS &&
            //             response.status == TRANSACTION_STATUS.SUCCESS &&
            //             response.transactionID ==
            //                 this.$root.$data.referenceNumber
            //         ) {
            //             this.changeView("lazada-transaction-complete");
            //         } else {
            //             this.changeView("transaction-complete");
            //         }
            //     });
            // });

            this.$pusher
                .subscribe("HCPAY_TRANSACTION_STATUS")
                .bind(this.$root.$data.transactionId, (response) => {
                    this.$root.$data.paymentOption = response.paymentOption;
                    if (
                        response.status in TRANSACTION_STATUS &&
                        response.status == TRANSACTION_STATUS.IN_PROGRESS &&
                        response.transactionID ==
                            this.$root.$data.referenceNumber
                    ) {
                        this.verifyFailCount--;
                        this.$root.$data.referenceNumber =
                            this.$root.$data.referenceNumber;
                        this.changeView("lazada-payment-in-progress");
                    } else if (
                        (response.status in TRANSACTION_STATUS &&
                            response.status == TRANSACTION_STATUS.CANCELLED &&
                            response.transactionID ==
                                this.$root.$data.referenceNumber) ||
                        (response.status in TRANSACTION_STATUS &&
                            response.status == TRANSACTION_STATUS.FAILED &&
                            response.transactionID ==
                                this.$root.$data.referenceNumber) ||
                        (response.status in TRANSACTION_STATUS &&
                            response.status == TRANSACTION_STATUS.REFUNDED &&
                            response.transactionID ==
                                this.$root.$data.referenceNumber)
                    ) {
                        this.changeView("lazada-user-canceled");
                    } else if (
                        response.status in TRANSACTION_STATUS &&
                        response.status == TRANSACTION_STATUS.SUCCESS &&
                        response.transactionID ==
                            this.$root.$data.referenceNumber
                    ) {
                        this.changeView("lazada-transaction-complete");
                    } else {
                        this.changeView("transaction-complete");
                    }
                });
        },
    },
    watch: {
        verifyFailCount(val) {
            let vm = this;
            if (val == 1) {
                vm.$dialog
                    .alert("", {
                        view: "session-expired-try-again",
                        html: true,
                        customClass: "dialog-sm",
                    })
                    .then(vm.timerCallback)
                    .catch(() => {
                        axios
                            .post(
                                "lazada-hcpay/cancel_request?tid=" +
                                    this.$root.$data.transactionId
                            )
                            .then((response) => {
                                this.changeView("lazada-user-canceled");
                            })
                            .catch((error) => {
                                this.changeView("lazada-technical-issue");
                            });
                    });
            } else if (val > 1) {
                vm.$dialog
                    .alert("", {
                        view: "session-expired-back-to-store",
                        html: true,
                        customClass: "dialog-sm",
                    })
                    .then(() => {
                        axios
                            .post(
                                "lazada-hcpay/cancel_request?tid=" +
                                    this.$root.$data.transactionId
                            )
                            .then((response) => {
                                this.changeView("lazada-user-canceled");
                            })
                            .catch((error) => {
                                this.changeView("lazada-technical-issue");
                            });
                    });
            }
        },
    },
};
</script>
<style scoped>
.accountTypeIcon {
    height: auto;
    width: 1.5rem;
}
.verifyIdentityStepIcon {
    height: auto;
    width: 2.5rem;
}
.lazada-hc-logo {
    /* Layout Properties */
    top: 14px;
    left: 36px;
    width: 100%;
    height: 52px;
    /* UI Properties */
    background: transparent url("/img/lazada/logos_desktop.png") center
        no-repeat padding-box;
    opacity: 1;
}

.step-style {
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.004em;
    text-align: left;
}

.custom-instruction {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.005em;
    text-align: left;
}

.headline-custom {
    font-family: Roboto;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.15000000596046448px;
    text-align: center;
}

.custom-expiration {
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: 0em;
    text-align: center;
}

.custom-download {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.0025em;
    text-align: center;
}
</style>
